import { computed } from 'mobx';
import { PartialDeep } from 'type-fest';

import { translate } from 'services/i18nService';
import { AbstractTheme, CampaignFlagsMap, ControlledFeaturesMap, Theme } from 'themes/themes.types';
import { getThemePart } from 'themes/utils';

import styles from './BonusTokensTheme.css';


export default class BonusTokensTheme extends AbstractTheme {
  static CFS: ControlledFeaturesMap = {};
  static CAMPAIGN_FLAGS: CampaignFlagsMap = {
    HEADER_CTA: 'BONUS_TOKENS_HEADER_CTA',
    BUY_TOKENS_MODAL: 'BONUS_TOKENS_BUY_TOKENS_MODAL',
  };

  @computed get theme(): PartialDeep<Theme> {
    return {
      headerCTA: getThemePart<'headerCTA'>(BonusTokensTheme.CAMPAIGN_FLAGS.HEADER_CTA, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          wrapperClass: styles.headerCTAWrapper,
          title: translate('epay.get.free.tokens',
            { 0: campaign.campaignDetails.bonusTokenAmount }
          ),
        };
      }),

      buyTokensModal: getThemePart<'buyTokensModal'>(BonusTokensTheme.CAMPAIGN_FLAGS.BUY_TOKENS_MODAL, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          headerClass: styles.buyTokensModalHeader,
          titleClass: styles.buyTokensModalTitle,
          title: translate('epay.epay.bonus.tokens.amount'),
          text: translate('epay.epay.with.first.purchase',
            { 0: campaign.campaignDetails.bonusTokenAmount }
          ),
        };
      }),

    };
  }
}
